<h3>Crear nuevo término</h3>
<app-term-condition-form
    (onSubmit)="submitHandler($event)"
    mode="create"
></app-term-condition-form>

<div class="button-container">
    <fs-ui-button  routerLink="/system-settings/terms-and-conditions" [type]="'tertiary'" [label]="'Regresar'"></fs-ui-button>
</div>